import { fund, fundSections } from '../../models/content';

export default function V2FundPage() {
  return (
    <main>
      <section className="page-hero">
        <div className="wrap">
          <span className="v2-badge">
            <span className="dot" />
            {fund.heroBadge}
          </span>
          <h1>
            {fund.heroTitle.map((p, i) =>
              typeof p === 'string' ? (
                <span key={i}>{p}</span>
              ) : (
                <span key={i} className="it">
                  {p.it}
                </span>
              )
            )}
          </h1>
          <p className="sub">{fund.heroSub}</p>
        </div>
      </section>

      <section>
        <div className="wrap">
          <div className="hybrid">
            <span className="kicker">Hybrid Structure</span>
            <h2 className="hybrid-title">
              <span className="it">Downside protection</span> + Upside participation.
            </h2>

            <div className="duo">
              <div className="blob">Debt</div>
              <div className="plus">+</div>
              <div className="blob alt">Equity Options / Equity</div>
            </div>
            <ul className="labels">
              <li>Downside Protection</li>
              <li>Upside Participation</li>
            </ul>

            <ul className="process-flow">
              <li className="pf-card">
                <div className="pf-head">
                  <span className="pf-num">01</span>
                  <span className="pf-name">Invest</span>
                </div>
                <h3 className="pf-label">Solve For</h3>
                <ul className="pf-items">
                  <li>Capital Structure</li>
                  <li>Rationalize Operations</li>
                  <li>Corporate Governance</li>
                </ul>
              </li>
              <li className="pf-card">
                <div className="pf-head">
                  <span className="pf-num">02</span>
                  <span className="pf-name">Growth &amp; Turnaround</span>
                </div>
                <h3 className="pf-label">Harvest Cash</h3>
                <ul className="pf-items">
                  <li>Sustainable Debt at Current Pay</li>
                  <li>Recover Majority of Invested Capital</li>
                  <li>Value Creation</li>
                </ul>
              </li>
              <li className="pf-card">
                <div className="pf-head">
                  <span className="pf-num">03</span>
                  <span className="pf-name">Exit</span>
                </div>
                <h3 className="pf-label">Exit</h3>
                <ul className="pf-items">
                  <li>Refinance of Debt</li>
                  <li>IPO</li>
                  <li>Strategic Sale</li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </section>

      <section id={fundSections.operate} className="strategy-v2 fund-section-anchor">
        <div className="wrap">
          <div className="head">
            <span className="kicker">01</span>
            <h2>
              How Do We <span className="it">Operate?</span>
            </h2>
          </div>
          <ul className="pillars op-grid">
            <li className="pillar">
              <span className="bg-num">01</span>
              <span className="eyebrow">Approach</span>
              <p>
                Designed to be significant equity-oriented, we believe in value investing in scalable businesses facing capital issues with
                demonstrated past track records.
              </p>
            </li>
            <li className="pillar">
              <span className="bg-num">02</span>
              <span className="eyebrow">Partnership</span>
              <p>
                We seek to work with promoters who have demonstrated unwavering commitment and are receptive to implementing a focused
                resurgence strategy. We recognise that every business and transaction is unique in nature.
              </p>
            </li>
            <li className="pillar">
              <span className="bg-num">03</span>
              <span className="eyebrow">Structure</span>
              <p>
                Our investments are specifically engineered to provide a holistic solution to each of our portfolio companies, and are
                predominantly structured through a combination of debt and significant equity.
              </p>
            </li>
            <li className="pillar">
              <span className="bg-num">04</span>
              <span className="eyebrow">Protection</span>
              <p>
                The debt structure provides downside risk protection and an avenue to seek progressive returns on investments from cash flows.
              </p>
            </li>
          </ul>
        </div>
      </section>

      <section id={fundSections.contribute} className="fund-section-anchor">
        <div className="wrap">
          <div className="fund-contribute-head">
            <span className="kicker">02</span>
            <h2>
              How Do We <span className="it">Contribute?</span>
            </h2>
            <p>
              We develop a fundamentally strong working relationship with promoters and management to ensure that a strong resurgence strategy
              is effectively implemented.
            </p>
            <p className="fund-contribute-sub">
              We work actively with the management of investee entities in:
            </p>
          </div>

          <ul className="steps">
            <li className="step">
              <div className="num">01</div>
              <div className="body">Formulating a comprehensive turnaround plan.</div>
            </li>
            <li className="step">
              <div className="num">02</div>
              <div className="body">Identifying ways to improve the key financial levers of a business.</div>
            </li>
            <li className="step">
              <div className="num">03</div>
              <div className="body">Upgrading existing internal controls, systems, and processes.</div>
            </li>
            <li className="step">
              <div className="num">04</div>
              <div className="body">Strengthening corporate governance and improving management.</div>
            </li>
          </ul>
        </div>
      </section>

      <section id={fundSections.addValue} className="fund-section-anchor">
        <div className="add-value-block">
          <span className="kicker">03</span>
          <h2>
            How Do We <span className="it">Add Value</span> to Our Investors?
          </h2>
          <p>
            Our primary aim is to provide our portfolio companies with a sustainable capital solution — one that enables them to scale their
            operations with minimal additional support. We seek to accomplish this objective by engineering an optimised investment structure
            that specifically caters to each portfolio company’s individual requirements.
          </p>
          <p>
            We seek to recover invested capital through the company’s cash flows, while actively creating an exit for our equity holding in
            the company.
          </p>
        </div>
      </section>
    </main>
  );
}
